<div class="col-12 padding-unset" style="margin-top: 5px;margin-bottom:10px;">
    <div class="grid p-justify-end" style="margin-bottom:15px;" [ngClass]="isAdminstrator ? '' : 'space-when-add-recipient-button-hidden'" >
        <div class="col-10"></div>
        <div class="col-2">
            <button style="float:right;" pButton type="button" icon="pi pi-plus" label="Add New Recipient Profile" class="p-button-info"
            (click)="showAddRecipientDialog()" *ngIf="isAdminstrator"></button>
        </div>
    </div>

    <div class="userprofile">
        <!-- <div class="ui-g padding-unset"> -->
        <div class="padding-unset"
            [ngStyle]="{'font-size':'12px','background-color':'aliceblue','padding':'unset','height':'29px'}">


            <div class="p-inputgroup float-left">
                <span class="p-inputgroup-addon">Name</span>
                <input id="inputDisplayNameFilter" type="search" pInputText placeholder="Filter By Name"
                    (input)="filter('DisplayName',$event.target.value, this.filterColumns,this.dataList)">
            </div>


            <div class="p-inputgroup float-left">
                <span class="p-inputgroup-addon">Country</span>
                <input id="inputCountryFilter" type="search" pInputText placeholder="Filter By Country"
                    (input)="filter('Country',$event.target.value, this.filterColumns,this.dataList)">
            </div>

            <div class="p-inputgroup float-left">
                <span class="p-inputgroup-addon">Function</span>
                <input id="inputFunctionFilter" type="search" pInputText placeholder="Filter By Function"
                    (input)="filter('Function',$event.target.value, this.filterColumns,this.dataList)">
            </div>

            <div class="p-inputgroup float-left">
                <span class="p-inputgroup-addon">Supervisor</span>
                <input id="inputSupervisorNameFilter" type="search" pInputText placeholder="Filter By Supervisor"
                    (input)="filter('SupervisorName',$event.target.value, this.filterColumns,this.dataList)">
            </div>


            <div class="clearAll">
                <a style="cursor:pointer" [routerLink]="" (click)="clearFilter()">Clear All Filters</a>
            </div>

        </div>

        <!-- </div> -->
    </div>

    <!--PrimeNg DataView -->
    <p-dataView #dv class="recipientProfile" layout="list" [paginator]="true" [rows]="10" [value]="results"
        paginatorPosition="both" [hidden]="isHidden" pageLinks="5" [alwaysShowPaginator]="true" styleClass="hover">

        <ng-template let-searchResults pTemplate="listItem">
            <!-- <div class="ui-dataview-content ui-widget-content"> -->

            <div class="col-12">

                <div class="grid resShadow recipientDiv"
                    [ngClass]="!searchResults.IsActive ? 'recipient-disable-row' : ''">
                    <div class="col-12">
                        <div class="grid">
                            <div class="col-11">
                                <div class="grid">
                                    <div class="col-4">
                                        <span class="lbl">Name </span>
                                        {{searchResults.DisplayName}}
                                    </div>

                                    <div class="col-4">
                                        <span class="lbl">Email </span>
                                        {{searchResults.Email}}
                                    </div>

                                    <div class="col-4">
                                        <span class="lbl-115px">Country </span>
                                        {{searchResults.Country}}
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <span
                                    class="font-weight-bold">{{searchResults.IsActive ? 'Enabled' : 'Disabled'}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="grid">
                            <div class="col-11">
                                <div class="grid">
                                    <div class="col-4">
                                        <span class="lbl">Function &nbsp;</span>
                                        <span class="float-left" id="{{'editFunction'+searchResults.RecipientId}}">
                                            {{searchResults.Function}} </span>

                                        <p-dropdown id="{{'divEditFunction'+searchResults.RecipientId}}"
                                            class="display-none float-left" [options]="functionList"
                                            placeholder="Select Function" [(ngModel)]="selectedFunction"
                                            optionLabel="Name" 
                                            (onChange)="functionChange(searchResults)">
                                        </p-dropdown>

                                        <i id="{{'divEditFunctionIcon'+searchResults.RecipientId}}"
                                            (click)="editFunctionButtonClick(searchResults)"
                                            class="pi pi-pencil edit" *ngIf="canEditRecipientProfile(searchResults.Email)"></i>
                                        
                                        <i id="{{'divEditFunctionCancelIcon'+searchResults.RecipientId}}"
                                            (click)="editFunctionCancelButtonClick(searchResults)"
                                            class="pi pi-times editCancel" *ngIf="canEditRecipientProfile(searchResults.Email)"></i>
                                    </div>

                                    <div class="col-4">
                                        <span class="lbl">Supervisor &nbsp;</span>
                                        <span class="float-left" id="{{'editSupervisor'+searchResults.RecipientId}}">
                                            {{searchResults.SupervisorName}}</span>

                                        <div id="{{'divEditSupervisor'+searchResults.RecipientId}}"
                                            class="display-none float-left">
                                            <sein-user-search [id]="supervisorSearch"
                                                [searchApiUrl]="restApiURL +'{searchWord}'"
                                                [(ngModel)]="supervisorLookupModel"
                                                [defaultUserList]="userLookUpModelList"
                                                [ngModelOptions]="{standalone: true}" appendTo="body" [multiple]="false"
                                                placeholder="Search by name or email address"
                                                (onSelect)="supervisorOnSelect(searchResults)">
                                            </sein-user-search>
                                        </div>

                                        <i id="{{'divEditSupervisorIcon'+searchResults.RecipientId}}"
                                            (click)="editSupervisorButtonClick(searchResults)"
                                            class="pi pi-pencil edit" *ngIf="canEditRecipientProfile(searchResults.Email)"></i>
                                        <i id="{{'divEditSupervisorCancelIcon'+searchResults.RecipientId}}"
                                            (click)="editSupervisorCancelButtonClick(searchResults)"
                                            class="pi pi-times editCancel" *ngIf="canEditRecipientProfile(searchResults.Email)"></i>

                                    </div>
                                    <div class="col-4">
                                        <span class="lbl-115px">Contact Number &nbsp;</span>
                                        <span class="float-left" id="{{'editContact'+searchResults.RecipientId}}">
                                            {{searchResults.ContactNumber}}</span>

                                        <input id="{{'divEditContact'+searchResults.RecipientId}}" type="text"
                                            class="form-control input-box display-none float-left"
                                            (keypress)="validationService.contactNumberValidation($event)"
                                            [(ngModel)]="searchResults.ContactNumber" size=20 pInputText maxlength="30"
                                            (blur)="onBlurContactNumber(searchResults)">

                                        <i id="{{'divEditContactIcon'+searchResults.RecipientId}}"
                                            (click)="editContactButtonClick(searchResults)"
                                            class="pi pi-pencil edit" *ngIf="canEditRecipientProfile(searchResults.Email)"></i>
                                        <i id="{{'divEditContactCancelIcon'+searchResults.RecipientId}}"
                                            (click)="editContactCancelButtonClick(searchResults)"
                                            class="pi pi-times editCancel" *ngIf="canEditRecipientProfile(searchResults.Email)"></i>

                                    </div>
                                </div>
                            </div>
                            <div class="col-1">
                                <p-inputSwitch [(ngModel)]="searchResults.IsActive" (onChange)="changeRecipientProfileStatus($event,searchResults)"
                                    [ngStyle]="{'pointer-events':'visible'}" title="Enable/Disable"
                                    *ngIf="isAdminstrator"></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                    <div
                        [ngClass]="searchResults.IsActive && searchResults.ShowAddressBar ? 'col-12 header-bar' : 'col-12'">
                        <a class="addresses" [routerLink]=""
                            (click)="showRecipientAddresses(searchResults,searchResults.DisplayName)">Addresses

                            <i [ngStyle]="{'vertical-align': 'middle'}"
                                [ngClass]="searchResults.ShowAddressBar?'pi pi-caret-up' : 'pi pi-caret-down'"></i></a>
                    </div>

                    <div class="col-12 display-none" id="div{{searchResults.Email}}">

                        <div class="divCarousel addressBackground recipient-carousel">


                            <p-carousel #addressCarousel [value]="searchResults.AddressList" [numScroll]="4" [numVisible]="4">
                                <ng-template let-address pTemplate="item">

                                    <div class="col-12 addAddressCarousel" *ngIf="address.PersonFullName == 'Add'">
                                        <div class="addAddress">
                                            <a href="javascript:void(0)"
                                                (click)="showAddAddressDialog(searchResults,false)"
                                                class="addAddressAnchor" *ngIf = canEditRecipientProfile(searchResults.Email)>+ Add Address</a>
                                            
                                                <a href="javascript:void(0)"
                                                  class="addAddressAnchor" *ngIf = !canEditRecipientProfile(searchResults.Email)>+ Add Address</a>    

                                        </div>
                                    </div>
                                    <div class="addressCarousel" *ngIf="address.PersonFullName != 'Add'">
                                        <div class="shippingAddress address">

                                            <div class="addressBlock">
                                                <span class="font-weight-bold">{{address.PersonFullName}}</span>
                                                <div class="float-right">
                                                    <i *ngIf="!address.IsActiveDirectoryAddress && canEditRecipientProfile(searchResults.Email)"
                                                        class="pi pi-pencil edit-address-button"
                                                        (click)="showEditAddressDialog(address,searchResults.Email,searchResults.DisplayName)"
                                                        title="Edit"></i>
                                                </div>
                                                <div>{{address.AddressLine1}}</div>
                                                <div>{{address.AddressLine2}}</div>
                                                <div>{{address.AddressLine3}}</div>
                                                <div>{{address.City}}, {{address.State}} - {{address.PostalCode}}
                                                </div>
                                                <div>{{address.Country}}</div>
                                                <div><span>Phone Number : </span> {{address.Mobile}}</div>
                                                <div>{{address.OrgName}}</div>
                                            </div>
                                            <div class="grid p-justify-between addressBlockFooter">
                                                <div class="col-12"><span *ngIf="address.ModifiedBy!==undefined&&address.ModifiedBy!==null&&address.ModifiedBy!==''" style="font-size:10px !important;">Modifed by {{address.ModifiedBy}} at {{address.ModifiedAt | date: 'd-MMM-y h:mm:ss a'}}</span></div>
                                                <div class="col-12">
                                                    <p-checkbox inputId="{{'chk'+ address.AddressId}}"
                                                        name="{{searchResults.Email}}" [(ngModel)]="address.IsDefaultAddress" binary="true"
                                                        (onChange)="setAsDefaultOnChange(searchResults,address)"
                                                        label="Set as Default" *ngIf="canEditRecipientProfile(searchResults.Email)">
                                                    </p-checkbox>

                                                    <button pButton type="button" icon="pi pi-times" label="Remove"
                                                        (click)="removeAddress(searchResults,address.AddressId,false)"
                                                        class="p-button-danger removeButton float-right" *ngIf="canEditRecipientProfile(searchResults.Email)">
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </ng-template>
                            </p-carousel>
                        </div>
                    </div>
                </div>
            </div>
            <!-- </div> -->
        </ng-template>

        <ng-template pTemplate="paginatorleft" let-state>
            <span *ngIf="results != null" class="ui-paginator-first">
                Total Items : {{totalRecordCount}}
                {{ dv.totalRecords == totalRecordCount ? '' : '(Showing Items: '+ dv.totalRecords + ')'}}
            </span>
        </ng-template>
        <ng-template pTemplate="paginatorright" let-state>
            <span class="ui-paginator-first">
                {{ dv.totalRecords > 0 ? (state.page * state.rows) + 1 : 0 }}
                -
                {{ (state.rows * (state.page + 1)) > state.totalRecords ? state.totalRecords : (state.rows * (state.page + 1)) }}
                of {{dv.totalRecords}} Items</span>
        </ng-template>


    </p-dataView>

    <!--PrimeNg DataView -->
    <p-toast position="top-right"></p-toast>

    <!-- Address Pop up -->
    <app-address [visible]="showAddressDialog" [addressModel]="addressModel" [recipientEmail]="recipientEmail"
        (eventToReceiveNewCreatedAddress)="receiveAddressModelFromAddressComponent($event,false)"
        (eventToCloseAddressPopUp)="onAddressPopUpClose($event)" *ngIf="showAddressDialog == true"></app-address>

    <add-internal-recipient-profile [visible]="showRecipientDialog"
        (eventToReceiveNewCreatedRecipient)="receiveNewCreatedRecipient()"
        (eventToCloseAddRecipientPopUp)="onCloseAddRecipientPopUp()"></add-internal-recipient-profile>

    <p-confirmDialog #removeAddressConfirmDialog key="removeAddressConfirmDialog" header="Confirmation"
        icon="pi pi-exclamation-triangle" [closable]="false">
        <p-footer>
            <button type="button" pButton icon="pi pi-check" label="OK"
                (click)="removeAddressConfirmDialog.accept()"></button>
            <button type="button" pButton icon="pi pi-times" label="Cancel"
                (click)="removeAddressConfirmDialog.reject()"></button>
        </p-footer>
    </p-confirmDialog>

    <p-confirmDialog #changeProfileStatusConfirmDialog key="changeProfileStatusConfirmDialog" header="Confirmation"
        icon="pi pi-exclamation-triangle" [closable]="false">
        <p-footer>
            <button type="button" pButton icon="pi pi-check" label="OK"
                (click)="changeProfileStatusConfirmDialog.accept()"></button>
            <button type="button" pButton icon="pi pi-times" label="Cancel"
                (click)="changeProfileStatusConfirmDialog.reject()"></button>
        </p-footer>
    </p-confirmDialog>
</div>